import { render, staticRenderFns } from "./createLimit.vue?vue&type=template&id=1103a7bf&scoped=true"
import script from "./createLimit.vue?vue&type=script&lang=js"
export * from "./createLimit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1103a7bf",
  null
  
)

export default component.exports